import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';

class NavbarScroll {
    /**
     * @param {HTMLElement} mainnav 
     */
    constructor (mainnav) {
        /** @type {HTMLElement} */
        this.mainnav = mainnav;

        /** @type {HTMLDivElement} */
        this.mainnavContainer = this.mainnav.querySelector(".navbar-navwrap");
        /** @type {HTMLUListElement} */
        this.mainnavUl = this.mainnav.querySelector(".navbar-nav");
        /** @type {HTMLLIElement[]} */
        this.mainnavItems = this.mainnav.querySelectorAll(".nav-item");

        this.mainnavContainerWidth = this.mainnavContainer.getBoundingClientRect().width;

        this.navArrowWidth = 0;
        this.navArrows = {
            "previous": null,
            "next": null
        }

        this.currentPage = 0;
        this.itemPages = [[]];
        this.itemPagesWidth = [0];

        this.resizeTimeout;

        this.init();
    }

    /**
     * @param {('previous'|'next')} type
     * @param {boolean} addElem
     * 
     * @return void
     */
    addScrollArrow(type, addElem) {
        if (addElem && !this.navArrows[type]) {
            const navArrowButton = document.createElement('button');
            navArrowButton.tabIndex = -1;
            navArrowButton.type = 'button';
            navArrowButton.classList.add('btn', 'btn-link', 'nav-link', 'border-0');
            navArrowButton.textContent = (type == "previous" ? "<" : ">");
            navArrowButton.addEventListener("click", () => {
                this.scrollNav(type);
            });

            this.navArrows[type] = document.createElement("li");
            this.navArrows[type].classList.add("nav-item", "position-absolute", (type == "previous" ? "start-0" : "end-0"));
            this.navArrows[type].dataset.arrowType = type;
            this.navArrows[type].appendChild(navArrowButton);

            if (type == "previous") {
                this.mainnavUl.prepend(this.navArrows[type]);
            } else {
                this.mainnavUl.append(this.navArrows[type]);
            }

            this.navArrowWidth = this.navArrows[type].getBoundingClientRect().width;
        } else if (!addElem && this.navArrows[type]) {
            this.navArrows[type].remove();
            this.navArrows[type] = null;
        }
    }

    /**
     * @param {('previous'|'next')} type
     */
    scrollNav(type) {
        let addPreviousPadding = this.navArrowWidth;
        let scrollWidth = 0;

        if (type == 'previous') {
            if (this.currentPage == 1) {
                this.addScrollArrow('previous', false);
                addPreviousPadding = 0;
            }
            this.addScrollArrow('next', true);
            this.currentPage -= 1;
        } else {
            if (this.currentPage == 0) {
                this.addScrollArrow('previous', true);
            }
            this.currentPage += 1;
        }

        if (this.currentPage >= this.itemPages.length - 1) {
            this.addScrollArrow('next', false);
        }
        if (this.currentPage > 0) {
            for (let i = 0; i < this.currentPage; i++) {
                scrollWidth += this.itemPagesWidth[i];
            }
        }
        
        for (const item of this.mainnavItems) {
            item.style.transform = 'translateX(-' + (scrollWidth - addPreviousPadding) + 'px)';
        }
    }

    /**
     * @param {Event} event
     */
    focusEvent(event) {
        /** @type {HTMLLIElement} */
        const navLi = event.target.parentElement;

        if (parseInt(navLi.dataset.navPage) < this.currentPage) {
            this.scrollNav('previous');
        } else if (parseInt(navLi.dataset.navPage) > this.currentPage) {
            this.scrollNav('next');
        }
    }

    addScrollable() {
        this.addScrollArrow("previous", false);
        this.addScrollArrow("next", true);
    
        let pageIndex = 0;
        for (const item of this.mainnavItems) {
            if (
                item.getBoundingClientRect().width +
                this.itemPagesWidth[pageIndex] +
                (this.navArrowWidth * (pageIndex > 0 ? 2 : 1)) >
                this.mainnavContainerWidth
            ) {
                pageIndex += 1;
            }
    
            if (this.itemPages[pageIndex] === undefined) this.itemPages.push([]);
            if (this.itemPagesWidth[pageIndex] === undefined) this.itemPagesWidth.push(0);
            this.itemPages[pageIndex].push(item);
            this.itemPagesWidth[pageIndex] += item.getBoundingClientRect().width;

            item.dataset.navPage = pageIndex;
            item.addEventListener('focusin', event => {
                this.focusEvent(event);
            });
        }
    }

    removeScrollable() {
        this.addScrollArrow("previous", false);
        this.addScrollArrow("next", false);
    
        for (const item of this.mainnavItems) {
            item.classList.add("transition-none");
            item.style.transform = 'none';
        }
    
        this.navArrowWidth = 0;
        this.navArrows = {
            "previous": null,
            "next": null
        }
    
        this.currentPage = 0;
        this.itemPages = [[]];
        this.itemPagesWidth = [0];
    }

    init() {
        if (window.matchMedia('(min-width: 992px)').matches && this.mainnavUl.scrollWidth > this.mainnavContainerWidth) {
            this.addScrollable();
        }

        EventHandler.on(window, 'resize', () => {
            if (this.itemPagesWidth[0] !== 0) {
                this.removeScrollable();
            }
        
            if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.mainnavContainerWidth = this.mainnavContainer.getBoundingClientRect().width;
                for (const item of this.mainnavItems) {
                    item.classList.remove("transition-none");
                }

                if (window.matchMedia('(min-width: 992px)').matches && this.mainnavUl.scrollWidth > this.mainnavContainerWidth) {
                    this.addScrollable();
                }
            }, 500);
        });
    }
}

EventHandler.one(document, 'DOMContentLoaded', () => {
    new NavbarScroll(SelectorEngine.findOne('#mainnav'));
});

export default NavbarScroll;
